export const addHoursToTime = (hoursToAdd: number, date: Date) => {
	return date?.setTime(date?.getTime() + hoursToAdd * 60 * 60 * 1000);
};

export const isOneLessMinuteDifference = (date1: Date, date2: Date) => {
	const difference = Math.abs(date1 - date2);
	return difference < 60000;
};
